import { render, staticRenderFns } from "./PortfolioAmountOfMoneyWidget.vue?vue&type=template&id=5c294e61&scoped=true&"
import script from "./PortfolioAmountOfMoneyWidget.vue?vue&type=script&lang=js&"
export * from "./PortfolioAmountOfMoneyWidget.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioAmountOfMoneyWidget.vue?vue&type=style&index=0&id=5c294e61&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c294e61",
  null
  
)

export default component.exports